export default __webpack_public_path__ + "cb1b353c69b4659283926f87a03e98ae.svg";